module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/plusvalia_mobile.790a7435.svg";